module.exports = __webpack_public_path__ + "static/media/Commerical.05d84c42.jpg";